import "./Descargables.css";
import { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import Tite from "../pages/assets/img/imagenes actividades/Tite.png";
import ImgActividades from "./assets/img/imagenes actividades/ImgActividades.jpeg";
import ImgActividades2 from "./assets/img/imagenes actividades/ImgActividades2.jpeg";
import ImgActividades3 from "./assets/img/imagenes actividades/ImgActividades3.jpeg";
import ImgActividades4 from "./assets/img/imagenes actividades/ImgActividades4.jpeg";
import ImgActividades5 from "./assets/img/imagenes actividades/ImgActividades5.jpeg";
import ImgActividades6 from "./assets/img/imagenes actividades/ImgActividades6.jpeg";
import AppCardActividad from "../components/AppCardActividad";
import { getActividades, getConfigPagina, isApiConfigured } from "../services/api";
import ContenidoExtra from "../components/ContenidoExtra";

const defaultImgs = {
  instrumentos: [ImgActividades, ImgActividades4],
  colorea:      [ImgActividades2, ImgActividades5],
  misiones:     [ImgActividades3, ImgActividades6],
};

function Descargables() {
  const [instrumentos, setInstrumentos] = useState([]);
  const [colorea, setColorea] = useState([]);
  const [misiones, setMisiones] = useState([]);
  const [config, setConfig] = useState({
    titulo: null,
    subtitulo: null,
    contenido_extra: null,
    actividades_instrumentos_titulo: null,
    actividades_colorea_titulo: null,
    actividades_misiones_titulo: null,
  });
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: shouldReduceMotion ? 0 : 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (!isApiConfigured()) {
      setInstrumentos(defaultImgs.instrumentos.map((img) => ({ img, desc: "" })));
      setColorea(defaultImgs.colorea.map((img) => ({ img, desc: "" })));
      setMisiones(defaultImgs.misiones.map((img) => ({ img, desc: "" })));
      return;
    }

    getConfigPagina("actividades")
      .then((cfg) => { if (cfg) setConfig(cfg); })
      .catch(() => {});

    Promise.all([
      getActividades("instrumentos"),
      getActividades("colorea"),
      getActividades("misiones"),
    ])
      .then(([inst, col, mis]) => {
        const mapActividades = (data, defaultImgsArr) => {
          if (data && data.length > 0) {
            return data.map((a, i) => ({
              img: a.imagen || defaultImgsArr[i % defaultImgsArr.length],
              desc: a.titulo || "",
              descripcion: a.descripcion || "",
              id: a.id,
            }));
          }
          return defaultImgsArr.map((img) => ({ img, desc: "", descripcion: "" }));
        };

        setInstrumentos(mapActividades(inst, defaultImgs.instrumentos));
        setColorea(mapActividades(col, defaultImgs.colorea));
        setMisiones(mapActividades(mis, defaultImgs.misiones));
      })
      .catch(() => {
        setInstrumentos(defaultImgs.instrumentos.map((img) => ({ img, desc: "" })));
        setColorea(defaultImgs.colorea.map((img) => ({ img, desc: "" })));
        setMisiones(defaultImgs.misiones.map((img) => ({ img, desc: "" })));
      });
  }, []);

  return (
    <div className="actividades">
      <motion.div
        initial="hidden"
        animate="show"
        variants={sectionVariants}
      >
        <motion.div className="actividades-wrapper" variants={itemVariants}>
          <h1 className="actividades-title">{config.titulo || "Actividades educativas para descargar"}</h1>
        </motion.div>
        <motion.div className="tite-container" variants={itemVariants}>
          <img src={config.imagen || Tite} alt="Tite" className="tite" />
        </motion.div>
        <motion.div className="actividades-descripciones" variants={itemVariants}>
          <h3 className="actividades-descripcion">{config.subtitulo || "Disfruta de nuestros materiales educativos para niños donde y cuando quieras. Acompaña a tus pequeños en su aprendizaje con estos increíbles recursos."}</h3>
        </motion.div>
        <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.div className="home-instrumentos" variants={itemVariants}>
          <h1 className="home-instrumento">{config.actividades_instrumentos_titulo || "Instrumentos"}</h1>
        </motion.div>
        <motion.div className="activ-row" variants={itemVariants}>
          {instrumentos.map((item, index) => (
            <AppCardActividad
              key={index}
              img={item.img}
              desc={item.desc}
              descripcion={item.descripcion || ""}
              onClick={item.id ? undefined : () => {}}
              actividadId={item.id || undefined}
            />
          ))}
        </motion.div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.div className="home-colorean" variants={itemVariants}>
          <h1 className="home-colorea">{config.actividades_colorea_titulo || "Colorea"}</h1>
        </motion.div>
        <motion.div className="activ-row" variants={itemVariants}>
          {colorea.map((item, index) => (
            <AppCardActividad
              key={index}
              img={item.img}
              desc={item.desc}
              descripcion={item.descripcion || ""}
              onClick={item.id ? undefined : () => {}}
              actividadId={item.id || undefined}
            />
          ))}
        </motion.div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.div className="home-mision" variants={itemVariants}>
          <h1 className="home-misiones">{config.actividades_misiones_titulo || "Misiones"}</h1>
        </motion.div>
        <motion.div className="activ-row" variants={itemVariants}>
          {misiones.map((item, index) => (
            <AppCardActividad
              key={index}
              img={item.img}
              desc={item.desc}
              descripcion={item.descripcion || ""}
              onClick={item.id ? undefined : () => {}}
              actividadId={item.id || undefined}
            />
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
}

export default Descargables;
